import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUsersAvailable = createSelector(
    [
        (store: RootState) => store.formSubmittedSlice.userList,
        (store: RootState) => store.formSubmittedSlice.searchUserText,
        (store: RootState) => store.formSubmittedSlice.createFilters,
        (store: RootState) => store.formSubmittedSlice.selectedUsers
    ],
    (userList, searchText, createFilters, selectedUsers) => {
    const data = userList.filter(
        ({user, id, organization}) => {
            if (
                searchText
                && !user?.name.toLowerCase().includes(searchText?.toLowerCase().trim())
            ) {
                return false;
            }
               // Filtro por organization (Cliente)
               if (createFilters.organization.id && organization?.id !== Number(createFilters.organization.id)) {
                return false;
            }

            // Descarta los usuarios que ya están seleccionados o asignados
            if (selectedUsers.find(( { id: UserRoleId }) => UserRoleId === id)) {
                return false;
              }

            return true
        }
    );
    // Ordena la lista alfabeticamente
    const orderedList = [...data].sort((a, b) => {
        if (a.user.name && b.user.name && a.user.name < b.user.name) {
          return -1;
        }
        if (a.user.name && b.user.name && a.user.name > b.user.name) {
          return 1;
        }
        return 0;
      });
  
      return orderedList;
});
